/* ============================================================================
   accessibility-fixes.js: WCAG 2.2 AA patches for markup the theme doesn't
   write itself (Slick sliders, Nosto recommendation and search templates).
   Runs on load and again whenever new nodes are added (Nosto renders late).
   ============================================================================ */
(function () {
  // Slick wraps a <ul>'s <li> slides in div.slick-list > div.slick-track and
  // appends <button> arrows, so the <ul> no longer holds only <li> (WCAG 1.3.1).
  // Move the list role onto the track that actually holds the slides.
  function fixSlickLists(root) {
    root.querySelectorAll('ul.slick-initialized, ol.slick-initialized').forEach(function (list) {
      if (!list.hasAttribute('role')) list.setAttribute('role', 'none');
      var slickList = list.querySelector(':scope > .slick-list');
      if (slickList && !slickList.hasAttribute('role')) slickList.setAttribute('role', 'none');
      var track = list.querySelector(':scope > .slick-list > .slick-track');
      if (track && track.getAttribute('role') !== 'list' && track.querySelector(':scope > li')) {
        track.setAttribute('role', 'list');
      }
      // Slick's accessibility mode marks slides role="option" (a listbox item),
      // which clashes with the list role and nests links inside an option.
      if (track) {
        track.querySelectorAll(':scope > li[role="option"]').forEach(function (slide) {
          slide.setAttribute('role', 'listitem');
        });
      }
    });
  }

  // Product images inside a link with no alt text (Nosto templates). When the
  // tile already has a text link to the same product, the image is decorative;
  // otherwise it names the link, so it gets the product name.
  function fixImageAlts(root) {
    root.querySelectorAll('img:not([alt])').forEach(function (img) {
      var link = img.closest('a');
      if (!link) {
        img.setAttribute('alt', '');
        return;
      }
      if (link.textContent.trim() || link.getAttribute('aria-label')) {
        img.setAttribute('alt', '');
        return;
      }
      var tile = link.closest('li, .nosto-product, .ns-product');
      var name = '';
      if (tile) {
        var nameEl = tile.querySelector('.nosto-product-name, .ns-product-name, [class*="product-name"], [class*="product__title"]');
        if (nameEl) name = nameEl.textContent.trim();
        if (!name && tile.dataset.handle) name = tile.dataset.handle.replace(/-/g, ' ');
      }
      img.setAttribute('alt', name);
    });
  }

  // Nosto feed tiles link the product image (a CSS background) with an
  // invalid alt="" attribute on the <a>, so the link has no name. Use it as
  // the aria-label instead.
  function fixLinkNames(root) {
    root.querySelectorAll('a[alt]:not([aria-label])').forEach(function (link) {
      if (link.textContent.trim() || link.querySelector('img[alt]:not([alt=""])')) return;
      var name = link.getAttribute('alt').trim();
      if (name) link.setAttribute('aria-label', name);
    });
  }

  function run() {
    fixLinkNames(document);
    fixSlickLists(document);
    fixImageAlts(document);
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () {
      queued = false;
      run();
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', run);
  // Slick puts role="listbox"/"option" back each time an autoplaying slider
  // changes slide, so watch role changes as well as new nodes.
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length || mutations[i].type === 'attributes') return schedule();
    }
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['role']
  });
})();
